module.exports = __webpack_public_path__ + "static/media/p13_data.4a767e38.txt";